// extracted by mini-css-extract-plugin
export default {"drawer":"styles_drawer__PUObh","drawerActive":"styles_drawerActive__WchHU"};